import { Component, OnInit } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import * as xml2js from "xml2js";
import { NewsRss } from '../../pages/Services/news-rss';
import { FormGroup, FormControl, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router'
import { Directive, HostListener, Input } from '@angular/core'
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {
  newsData: any;

  RssData: NewsRss;
  constructor(private http: HttpClient) { }
  ngOnInit(): void {
    this.GetRssFeedData()
  }

  GetRssFeedData() {
    debugger
    const requestOptions: Object = {
      observe: "body",
      responseType: "text"
    };
      //.get<any>("https://gadgets.ndtv.com/rss/feeds", requestOptions)
    this.http
      .get<any>("https://health.economictimes.indiatimes.com/rss/health-it", requestOptions)
      //.get<any>("https://timesofindia.indiatimes.com/rssfeeds/-2128838597.cms", requestOptions)
      .subscribe(data => {
        debugger
        let parseString = xml2js.parseString;
        parseString(data, (err, result: NewsRss) => {
          this.RssData = result;
          console.log(this.RssData)
        });
        
      });
  }

  navigateToNews(val) {
    window.open(val)
  }

}
